import { render } from "./TramiteObservaciones.vue?vue&type=template&id=525bac38"
import script from "./TramiteObservaciones.vue?vue&type=script&lang=js"
export * from "./TramiteObservaciones.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__